import { useQuery } from '@tanstack/react-query';
import { Navigate } from 'react-router-dom';
import { api } from '../lib/api';

// Where "/" lands, decided by what kind of box this is.
//
// A state broadband office's front door is the oversight queue; an ISP's is the project
// dashboard. Hard-coding either one gives half the fleet the wrong first screen. The
// deployment kind is set at provision time and is not editable in-app, so this cannot be
// flipped by a tenant.
//
// One shared query key with the sidebar, so this resolves from cache on every navigation
// after the first and never adds a visible hop.
export default function GrantorLanding() {
  const { data, isLoading, isError } = useQuery<{ deployment_kind?: string }>({
    queryKey: ['deployment-config-kind'],
    queryFn: () => api.get('/bead/config'),
    staleTime: 5 * 60 * 1000,
    retry: false,
  });

  // Render nothing rather than flashing the ISP dashboard for a frame and then
  // bouncing a state user to a different screen.
  if (isLoading) return null;

  // If the config call fails we fall back to the ISP dashboard: it is the safe default
  // (every box has one) and a grantor still reaches the queue from the sidebar.
  const kind = isError ? 'isp' : (data?.deployment_kind ?? 'isp');
  return <Navigate to={kind === 'grantor' ? '/grantor' : '/dashboard'} replace />;
}
